<template>
  <div class="preview-container">
    <div class="title-box">
      <div class="title">{{ schemeName }}</div>
      <div class="stu-info">
        <span>姓名:</span>
        <span>{{ user.name }}</span>
        <span class="stu-info">科类:</span>
        <span v-if="[1, 3, 5].includes(infos.majorType)">物理</span>
        <span v-if="[2, 4].includes(infos.majorType)">历史</span>
        <span>{{ infos.subject1 }}</span>
        <span>{{ infos.subject2 }}</span>
        <span class="stu-info">批次:</span>
        <span>{{ batch }}</span>
        <span v-if="batch.indexOf('提前')>=0 || batch === '本科普通批单设'" class="stu-info">招生类别:</span>
        <span v-if="batch.indexOf('提前')>=0 || batch === '本科普通批单设'">{{ schemeRecruitType }}</span>
        <span class="stu-info">分数:</span>
        <span>{{ infos.score }}</span>
        <span class="stu-info">位次:</span>
        <span>{{ infos.precedence }}</span>
      </div>
    </div>

    <div class="handle-box">
      <el-button type="primary" plain @click="toggleExpansionAll()">{{expandTxt}}<i :class="expandObject"></i></el-button>
      <el-button type="primary" plain @click="$refs.$schemeDialog.open()">全景预览</el-button>
    </div>

    <div class="table-section">
      <!--普通批次 -->
      <el-table class="ui-table" :data="tableDataFilter" v-loading="loading" :border="false" v-if="pttable" key="ptTable"
        ref="elTable" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        style="width: 100%;" :row-key="row => row.id" :expand-row-keys="expandRowKeys" @expand-change="handleExpandChange"
        @sort-change="handleSortChange" :cell-style="{ background: '#fff2e7' }">
        <!-- 展开表格 S -->
        <el-table-column type="expand" width="30px">
          <template slot="header" slot-scope="scope">
            <div class="el-table__expand-icon"
                 :class="isExpansion && `el-table__expand-icon--expanded`">
              <i class="el-icon el-icon-arrow-right"></i>
            </div>
          </template>
          <template slot-scope="props">
            <div class="tab-box" >
              <div class="tab-item" :class="{ 'is-active': props.row.showCheckMajor }"
                   @click="toggleCheckMajor(props, 1)">
                已选专业({{props.row.majorList.length}})
              </div>
              <div class="tab-item" :class="{ 'is-active': !props.row.showCheckMajor }"
                   @click="toggleCheckMajor(props, 2)">
                未选专业({{props.row.notMajorList.length}})
              </div>
            </div>
            <!-- 已选专业 -->
            <el-table v-if="props.row.showCheckMajor" :data="props.row.majorList" style="width: 100%;" >
              <ColProbability label="录取概率" align="center" width="88"/>
              <el-table-column prop="sort" width="90">
                <template slot-scope="child">
                  <div style="display: flex;align-items: center">
                    <!-- <span style="font-weight:bolder">{{ props.row.sort }}</span> -->
                    <el-popover placement="bottom-start" :ref="'popover-child-' + child.row.majorCode" width="290"
                      trigger="hover">
                      <div class="sortSection">
                        <div @click="tableChildRowSort(index, { parent: props, child })"
                          v-for="(item, index) in props.row.majorList"
                          :class="['sortSection-item is-major', { 'is-active': index === child.$index }]">
                          {{ index + 1 }}
                        </div>
                      </div>
                      <el-button plain class="sortSection-button" slot="reference" size="mini" type="success"
                        style="padding: 7px;">
                        {{ child.$index + 1 }}<i style="margin-left: 1px;" class="el-icon-arrow-down"></i>
                      </el-button>
                      <!-- <span style="font-weight:bolder" slot="reference">专业{{ child.$index + 1 }}</span> -->
                    </el-popover>
                    <el-popover v-if="child.row.examLimit" placement="top-start" width="600"  trigger="hover"
                      :content="child.row.examLimit">
                      <div slot="reference"><i class="el-icon-warning"
                          style="font-size: 16px;color: #f00;padding: 6px 10px;"></i></div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="majorCode" width="56" label="专业代码" align="center">
                <template slot-scope="scope">
                  <div style="font-weight:bolder">{{ scope.row.majorCode }}</div>
                  <img v-if="scope.row.isNewMajor == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
                </template>
              </el-table-column>
              <el-table-column align="center" prop="level" label="包含专业及等级排名" min-width="240">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: flex-start;justify-content:space-between;">
                    <div style="text-align: left;">{{ scope.row.majorName }}{{ scope.row.level ? '【' + scope.row.level + '】' : '' }}</div>
                    <img v-if="scope.row.majorDesc" width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="margin-left: 10px;cursor: pointer" @click="introduceMajor(scope.row.majorDesc)">
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="msg2015" label="计划数/录取数|最高分/平均分/最低分|最高位次-最低位次" class-name="mergeTh" align="center">
                <el-table-column align="center" :label="MajorNowYear - 2 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2015 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear - 1 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2016 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2017 }}</template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="plan2018" :label="MajorPlanYear + '计划'" align="center" width="50px">
                <template slot-scope="scope">
                  <span v-if="scope.row.plan2018 > scope.row.plan2017" class="icon-top">{{ scope.row.plan2018 }}↑</span>
                  <span v-else-if="scope.row.plan2017 > scope.row.plan2018" class="icon-bottom">{{ scope.row.plan2018
                  }}↓</span>
                  <span v-else>{{ scope.row.plan2018 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="majorLimit" label="学费" align="center" width="80px"></el-table-column>
              <el-table-column width="70px" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small"
                             @click.native.prevent="deleteRow(props.$index, scope.$index, tableData[props.$index].majorList)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 未选专业 -->
            <el-table v-else :data="props.row.notMajorList" style="width: 100%;" >
              <ColProbability label="录取概率" align="center" width="88"/>
              <el-table-column prop="sort" width="90">
                <template slot-scope="child">
                  <div style="display: flex;align-items: center">
                    <!-- <span style="font-weight:bolder">{{ props.row.sort }}</span> -->
                    <el-popover placement="bottom-start" :ref="'popover-child-' + child.row.majorCode" width="290"
                                trigger="hover">
                      <div class="sortSection">
                        <div @click="tableChildRowSort(index, { parent: props, child })"
                             v-for="(item, index) in props.row.majorList"
                             :class="['sortSection-item is-major', { 'is-active': index === child.$index }]">
                          {{ index + 1 }}
                        </div>
                      </div>
                      <el-button plain class="sortSection-button" slot="reference" size="mini" type="success"
                                 style="padding: 7px;">
                        {{ child.$index + 1 }}<i style="margin-left: 1px;" class="el-icon-arrow-down"></i>
                      </el-button>
                      <!-- <span style="font-weight:bolder" slot="reference">专业{{ child.$index + 1 }}</span> -->
                    </el-popover>
                    <el-popover v-if="child.row.examLimit" placement="top-start" width="600"  trigger="hover"
                                :content="child.row.examLimit">
                      <div slot="reference"><i class="el-icon-warning"
                                               style="font-size: 16px;color: #f00;padding: 6px 10px;"></i></div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="majorCode" width="56" label="专业代码" align="center">
                <template slot-scope="scope">
                  <div style="font-weight:bolder">{{ scope.row.majorCode }}</div>
                  <img v-if="scope.row.isNewMajor == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
                </template>
              </el-table-column>
              <!--              <el-table-column prop="majorName" width="110"></el-table-column>-->
              <el-table-column align="center" prop="level" label="包含专业及等级排名" min-width="240">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: flex-start;justify-content:space-between;">
                    <div style="text-align: left;">{{ scope.row.majorName }}{{ scope.row.level ? '【' + scope.row.level + '】' : '' }}</div>
                    <img v-if="scope.row.majorDesc" width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="margin-left: 10px;cursor: pointer" @click="introduceMajor(scope.row.majorDesc)">
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="msg2015" label="计划数/录取数|最高分/平均分/最低分|最高位次-最低位次" class-name="mergeTh" align="center">
                <el-table-column align="center" :label="MajorNowYear - 2 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2015 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear - 1 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2016 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2017 }}</template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="plan2018" :label="MajorPlanYear + '计划'" align="center" width="50px">
                <template slot-scope="scope">
                  <span v-if="scope.row.plan2018 > scope.row.plan2017" class="icon-top">{{ scope.row.plan2018 }}↑</span>
                  <span v-else-if="scope.row.plan2017 > scope.row.plan2018" class="icon-bottom">{{ scope.row.plan2018
                    }}↓</span>
                  <span v-else>{{ scope.row.plan2018 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="majorLimit" label="学费" align="center" width="80px"></el-table-column>
              <!--              <el-table-column prop="" align="center" width="80px"></el-table-column>-->
              <!-- <el-table-column width="70px">
                  <template slot-scope="scopes">
                      <div class="sort-box">
                          <div class="sort-item">
                            <i class="el-icon-top" @click="risemajor(scopes,props)"></i>
                          </div>
                          <div class="sort-item">
                            <i class="el-icon-bottom" @click="declinemajor(scopes,props)"></i>
                          </div>
                      </div>
                  </template>
              </el-table-column> -->
              <el-table-column width="70px" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small"
                             @click.native.prevent="selectMajor(scope.$index, tableData[props.$index].majorList, props.$index)">选择
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <!-- 展开表格 E -->
        <ColProbability label="录取概率" align="left" width="84px" prop="probabilityNum" sortable="true"/>
        <el-table-column prop="programmeId" align="left" label="序列" width="74px">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center">
              <el-popover placement="bottom-start" :ref="'popover-' + scope.row.schoolCode" width="600" trigger="hover">
                <div class="sortSection">
                  <div @click="tableRowSort(index, scope)" v-for="(item, index) in tableData"
                    :class="['sortSection-item', { 'is-active': item.schemeNum === scope.row.schemeNum }]">
                    {{ item.schemeNum }}
                  </div>
                </div>
                <el-button class="sortSection-button" slot="reference" size="mini" type="primary" style="padding: 7px;">
                  {{ scope.row.schemeNum }}<i style="margin-left: 4px;" class="el-icon-arrow-down"></i>
                </el-button>
              </el-popover>
              <el-popover v-if="scope.row.schoolExamLimit" placement="top-start" width="600"  trigger="hover"
                :content="scope.row.schoolExamLimit">
                <div slot="reference"><i class="el-icon-warning"
                    style="font-size: 16px;color: #f00;padding: 6px 10px;"></i></div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="programmeName" label="专业组" width="105px">
          <template slot-scope="scope">
            <div class="flex-box">
              <el-popover
                v-show="scope.row.warning"
                class="warning-icon"
                placement="top-start"
                title=""
                width="700"
                trigger="hover">
                <template slot="reference">
                  <span><i class="el-icon-warning txt-red"></i></span>
                </template>
                <div style="white-space: pre-line; max-width: 660px">{{ normalizePopoverContent(scope.row.warning) }}</div>
              </el-popover>
              <div class="font-bold code-box" >{{ scope.row.schoolCode }}-{{ scope.row.groupCode }}</div>
            </div>
<!--            <div style="font-weight:bolder">{{ scope.row.schoolCode }}-{{ scope.row.groupCode }}</div>-->
            <img v-if="scope.row.isNewSchool == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
          </template>
        </el-table-column>
        <el-table-column label="院校名称" min-width="196px">
          <template slot-scope="scope">
            <div style="width: 100%;display: flex;align-items: flex-start;justify-content:space-between;padding: 0 3px">
              <div style="flex: 1;">
                <div><span style="font-weight:bolder">{{ scope.row.schoolName }}</span></div>
                <div class="name-tag" v-if="scope.row.level || scope.row.city || scope.row.levelMsg">
                  <span>{{ scope.row.level }}</span>
                  <span>{{ scope.row.city }}</span>
                  <span>{{ scope.row.levelMsg }}</span>
                </div>
                <div class="name-tag">
                  <span :style="{ color: scope.row.majorPlan === '专业清' || scope.row.majorPlan === '一专再分' ? 'red' : '' }">{{ scope.row.majorPlan }}</span>
                  <span>排名:{{ scope.row.sortNum }}</span>
                  <span>{{ scope.row.rateGraduate }}</span>
                </div>
              </div>
              <img width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="cursor: pointer; margin-top: 3px;" @click="introduceSchool(scope.row.schoolCode)">
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="subject" label="再选要求" width="38px"></el-table-column>
        <el-table-column align="center" prop="recruitType" label="类别" width="62px"></el-table-column>

        <el-table-column prop="toudang2015" label="计划数|投档数" class-name="mergeTh" align="center">
          <el-table-column prop="toudang2019" :label="nowYear - 2 + ''" class-name="mergeTh-child" align="center"
            min-width="72px"></el-table-column>
          <el-table-column prop="toudang2020" :label="nowYear - 1 + ''" class-name="mergeTh-child" align="center"
                           min-width="72px"></el-table-column>
          <el-table-column prop="toudang2021" :label="nowYear + ''" class-name="mergeTh-child" align="center"
                           min-width="72px">
            <template slot-scope="scope">
              <b>{{ scope.row.toudang2021 }}</b>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="shift_line2019" label="投档线" align="center" class-name="mergeTh">
          <el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2019" :label="nowYear - 2 + ''"
                           min-width="50px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2020" :label="nowYear - 1 + ''"
                           min-width="50px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2021" :label="nowYear + ''"
                           min-width="50px">
            <template slot-scope="scope">
              <b>{{ scope.row.shiftLine2021 }}</b>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="ranking2019" label="投档位次" align="center" class-name="mergeTh">
          <el-table-column align="center" class-name="mergeTh-child" prop="ranking2019" :label="nowYear - 2 + ''"
                           min-width="76px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="ranking2020" :label="nowYear - 1 + ''"
                           min-width="76px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="ranking2021" :label="nowYear + ''"
                           min-width="76px">
            <template slot-scope="scope">
              <b>{{ scope.row.ranking2021 }}</b>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="PlanYear + '计划'" align="center" width="45px">
          <template slot-scope="scope">
            <span v-if="scope.row.plan2022 > scope.row.plan2021" class="icon-top">
              {{ scope.row.plan2022 }}<i>↑</i>
            </span>
            <span v-else-if="scope.row.plan2021 > scope.row.plan2022" class="icon-bottom">
              {{ scope.row.plan2022 }}<i>↓</i>
            </span>
            <span v-else>{{ scope.row.plan2022 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服从调剂" width="76px">
          <template slot-scope="scope">
            <span style="float: right;font-weight:bolder">
              <span style="margin-left: 30px;" v-show="Admission">{{ scope.row.majorPlan }}|</span>
              <el-radio-group v-model="scope.row.schemeChange" @change="schemeChangeChange(scope.row.schemeChange, scope.row)">
                <el-radio label="0" style="margin-right: 6px">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="40">
          <template slot-scope="scope">
            <el-button type="text" size="small"
                       @click.native.prevent="deleteScheme(scope.$index, tableData, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--提前批次 -->
      <el-table class="ui-table" :data="tableDataFilter" v-loading="loading" :border="false" v-show="tqtable" key="tqTable"
        ref="elTable" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        style="width: 100%;" :row-key="row => row.id" :expand-row-keys="expandRowKeys" @expand-change="handleExpandChange"
        @sort-change="handleSortChange" :cell-style="{ background: '#fff2e7' }">
        <!-- 展开表格 S -->
        <el-table-column type="expand" width="30px">
          <template slot="header" slot-scope="scope">
            <div @click="toggleExpansionAll" class="el-table__expand-icon" :class="isExpansion && `el-table__expand-icon--expanded`">
              <i class="el-icon el-icon-arrow-right"></i>
            </div>
          </template>
          <template slot-scope="props">
            <div class="tab-box" >
              <div class="tab-item" :class="{ 'is-active': props.row.showCheckMajor }"
                   @click="toggleCheckMajor(props, 1)">
                已选专业({{props.row.majorList.length}})
              </div>
              <div class="tab-item" :class="{ 'is-active': !props.row.showCheckMajor }"
                   @click="toggleCheckMajor(props, 2)">
                未选专业({{props.row.notMajorList.length}})
              </div>
            </div>
            <!-- 已选专业 -->
            <el-table v-if="props.row.showCheckMajor" :data="props.row.majorList" style="width: 100%;" >
              <el-table-column width="28px"><span></span></el-table-column>
<!--              <ColProbability label="录取概率" align="center" width="88"/>-->
              <el-table-column prop="sort" width="85">
                <template slot-scope="child">
                  <div style="display: flex;align-items: center">
                    <!-- <span style="font-weight:bolder">{{ props.row.sort }}</span> -->
                    <el-popover placement="bottom-start" :ref="'popover-child-' + child.row.majorCode" width="290"
                      trigger="hover">
                      <div class="sortSection">
                        <div @click="tableChildRowSort(index, { parent: props, child })"
                             v-for="(item, index) in props.row.majorList"
                             :class="['sortSection-item is-major', { 'is-active': index === child.$index }]">
                          {{ index + 1 }}
                        </div>
                      </div>
                      <el-button plain class="sortSection-button" slot="reference" size="mini" type="success"
                                 style="padding: 7px;">
                        {{ child.$index + 1 }}<i style="margin-left: 1px;" class="el-icon-arrow-down"></i>
                      </el-button>
                      <!-- <span style="font-weight:bolder" slot="reference">{{ child.row.sort }}</span> -->
                    </el-popover>
                    <el-popover v-if="child.row.examLimit" placement="top-start" width="600"  trigger="hover"
                      :content="child.row.examLimit">
                      <div slot="reference"><i class="el-icon-warning"
                          style="font-size: 16px;color: #f00;padding: 6px 10px;"></i></div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="majorCode" label="专业代码" width="56" align="center">
                <template slot-scope="scope">
                  <div style="font-weight:bolder">{{ scope.row.majorCode }}</div>
                  <img v-if="scope.row.isNewMajor == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
                </template>
              </el-table-column>
              <el-table-column align="center" prop="level" label="包含专业及等级排名" min-width="240">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: flex-start;justify-content:space-between;">
                    <div style="text-align: left;">{{ scope.row.majorName }}{{ scope.row.level ? '【' + scope.row.level + '】' : '' }}</div>
                    <img v-if="scope.row.majorDesc" width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="margin-left: 10px;cursor: pointer" @click="introduceMajor(scope.row.majorDesc)">
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="msg2015" label="计划数/录取数|最高分/平均分/最低分|最高位次-最低位次" class-name="mergeTh" align="center">
                <el-table-column align="center" :label="MajorNowYear - 2 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2015 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear - 1 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2016 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2017 }}</template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="plan2018" :label="MajorPlanYear + '计划'" align="center" width="50px">
                <template slot-scope="scope">
                  <span v-if="scope.row.plan2018 > scope.row.plan2017" class="icon-top">{{ scope.row.plan2018 }}↑</span>
                  <span v-else-if="scope.row.plan2017 > scope.row.plan2018" class="icon-bottom">{{ scope.row.plan2018
                  }}↓</span>
                  <span v-else>{{ scope.row.plan2018 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="majorLimit" label="学费" align="center" width="80px"></el-table-column>
              <!-- <el-table-column width="70">
                    <template slot-scope="scopes">
                        <div class="sort-box">
                            <div class="sort-item">
                                <i class="el-icon-top" @click="risemajor(scopes,props)"></i>
                            </div>
                            <div class="sort-item">
                                <i class="el-icon-bottom" @click="declinemajor(scopes,props)"></i>
                            </div>
                        </div>
                    </template>
                </el-table-column> -->
              <el-table-column width="70px" label="操作" align="center">
                <template slot-scope="scope">
                  <!-- <el-dropdown trigger="click" style="margin: 0; padding-right: 5px;">
                       <span class="el-dropdown-link" :class="props.row.sort?'scheme':'not-scheme'"
                             style="margin: 0;cursor: pointer;">
                         <el-button type="text" size="small" style="color: #67C23A">修改</el-button>
                       </span>
                           <el-dropdown-menu slot="dropdown">
                               <el-dropdown-item v-for="(item,index) in majorNameList" :key="index" :command="item.label"
                                                 style="padding: 0;text-align: center;">
                        <span
                       @click="updateMajor(props.$index, scope.$index, JSON.stringify(tableData[props.$index].majorList), item.label)"
                       style="width: 60px;padding: 10px;">{{ item.label }} </span>
                               </el-dropdown-item>
                           </el-dropdown-menu>
                       </el-dropdown> -->
                  <el-button type="text" size="small"
                    @click.native.prevent="deleteRow(props.$index, scope.$index, tableData[props.$index].majorList)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 未选专业 -->
            <el-table v-else :data="props.row.notMajorList" style="width: 100%;" >
              <el-table-column width="28px"><span></span></el-table-column>
              <!--              <ColProbability label="录取概率" align="center" width="88"/>-->
              <el-table-column prop="sort" width="85">
                <template slot-scope="child">
                  <div style="display: flex;align-items: center">
                    <!-- <span style="font-weight:bolder">{{ props.row.sort }}</span> -->
                    <el-popover placement="bottom-start" :ref="'popover-child-' + child.row.majorCode" width="290"
                                trigger="hover">
                      <div class="sortSection">
                        <div @click="tableChildRowSort(index, { parent: props, child })"
                             v-for="(item, index) in props.row.majorList"
                             :class="['sortSection-item is-major', { 'is-active': index === child.$index }]">
                          {{ index + 1 }}
                        </div>
                      </div>
                      <el-button plain class="sortSection-button" slot="reference" size="mini" type="success"
                                 style="padding: 7px;">
                        {{ child.$index + 1 }}<i style="margin-left: 1px;" class="el-icon-arrow-down"></i>
                      </el-button>
                      <!-- <span style="font-weight:bolder" slot="reference">{{ child.row.sort }}</span> -->
                    </el-popover>
                    <el-popover v-if="child.row.examLimit" placement="top-start" width="600"  trigger="hover"
                                :content="child.row.examLimit">
                      <div slot="reference"><i class="el-icon-warning"
                                               style="font-size: 16px;color: #f00;padding: 6px 10px;"></i></div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="majorCode" width="56" label="专业代码" align="center">
                <template slot-scope="scope">
                  <div style="font-weight:bolder">{{ scope.row.majorCode }}</div>
                  <img v-if="scope.row.isNewMajor == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
                </template>
              </el-table-column>
              <el-table-column align="center" prop="level" label="包含专业及等级排名" min-width="240">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: flex-start;justify-content:space-between;">
                    <div style="text-align: left;">{{ scope.row.majorName }}{{ scope.row.level ? '【' + scope.row.level + '】' : '' }}</div>
                    <img v-if="scope.row.majorDesc" width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="margin-left: 10px;cursor: pointer" @click="introduceMajor(scope.row.majorDesc)">
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="msg2015" label="计划数/录取数|最高分/平均分/最低分|最高位次-最低位次" class-name="mergeTh" align="center">
                <el-table-column align="center" :label="MajorNowYear - 2 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2015 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear - 1 + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2016 }}</template>
                </el-table-column>
                <el-table-column align="center" :label="MajorNowYear + ''" min-width="240px">
                  <template slot-scope="scope">{{ scope.row.msg2017 }}</template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="plan2018" :label="MajorPlanYear + '计划'" align="center" width="50px">
                <template slot-scope="scope">
                  <span v-if="scope.row.plan2018 > scope.row.plan2017" class="icon-top">{{ scope.row.plan2018 }}↑</span>
                  <span v-else-if="scope.row.plan2017 > scope.row.plan2018" class="icon-bottom">{{ scope.row.plan2018
                    }}↓</span>
                  <span v-else>{{ scope.row.plan2018 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="majorLimit" label="学费" align="center" width="80px"></el-table-column>
              <!-- <el-table-column width="70">
                    <template slot-scope="scopes">
                        <div class="sort-box">
                            <div class="sort-item">
                                <i class="el-icon-top" @click="risemajor(scopes,props)"></i>
                            </div>
                            <div class="sort-item">
                                <i class="el-icon-bottom" @click="declinemajor(scopes,props)"></i>
                            </div>
                        </div>
                    </template>
                </el-table-column> -->
              <el-table-column width="70px" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small"
                             @click.native.prevent="selectMajor(scope.$index, tableData[props.$index].majorList, props.$index)">选择
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <!-- 展开表格 E -->
        <ColProbabilityTea label="录取概率" align="left" width="84px" prop="probabilityNum" sortable="true"/>
        <el-table-column prop="programmeId" label="序列" width="74px">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center">
              <!-- <span style="font-weight:bolder">{{ scope.row.schemeName }}</span> -->
              <el-popover placement="bottom-start" :ref="'popover-' + scope.row.schoolCode" width="600" trigger="hover">
                <div class="sortSection">
                  <div @click="tableRowSort(index, scope)" v-for="(item, index) in tableData"
                    :class="['sortSection-item', { 'is-active': item.schemeNum === scope.row.schemeNum }]">
                    {{ item.schemeNum }}
                  </div>
                </div>
                <el-button class="sortSection-button" slot="reference" size="mini" type="primary">
                  {{ scope.row.schemeNum }}<i style="margin-left: 4px;" class="el-icon-arrow-down"></i>
                </el-button>
              </el-popover>
              <el-popover v-if="scope.row.schoolExamLimit" placement="top-start" width="600"  trigger="hover"
                :content="scope.row.schoolExamLimit">
                <div slot="reference"><i class="el-icon-warning"
                    style="font-size: 16px;color: #f00;padding: 6px 10px;"></i></div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="programmeName" label="专业组" width="105px" align="center">
          <template slot-scope="scope">
            <div class="flex-box">
              <el-popover
                v-show="scope.row.warning"
                class="warning-icon"
                placement="top-start"
                title=""
                width="700"
                trigger="hover">
                <template slot="reference">
                  <span><i class="el-icon-warning txt-red"></i></span>
                </template>
                <div style="white-space: pre-line; max-width: 660px">{{ normalizePopoverContent(scope.row.warning) }}</div>
              </el-popover>
              <div class="font-bold code-box" >{{ scope.row.schoolCode }}-{{ scope.row.groupCode }}</div>
            </div>
            <img v-if="scope.row.isNewSchool == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
          </template>
        </el-table-column>
        <el-table-column label="院校名称" min-width="196px">
          <template slot-scope="scope">
            <div style="width: 100%;display: flex;align-items: flex-start;justify-content:space-between;padding: 0 3px">
              <div style="flex: 1;">
                <div><span style="font-weight:bolder">{{ scope.row.schoolName }}</span></div>
                <div class="name-tag" v-if="scope.row.level || scope.row.city || scope.row.levelMsg">
                  <span>{{ scope.row.level }}</span>
                  <span>{{ scope.row.city }}</span>
                  <span>{{ scope.row.levelMsg }}</span>
                </div>
                <div class="name-tag">
                  <span :style="{ color: scope.row.majorPlan === '专业清' || scope.row.majorPlan === '一专再分' ? 'red' : '' }">{{ scope.row.majorPlan }}</span>
                  <span>{{ scope.row.rateGraduate }}</span>
                </div>
              </div>
              <img width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="cursor: pointer; margin-top: 3px;" @click="introduceSchool(scope.row.schoolCode)">
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="subject" label="再选要求" width="38px"></el-table-column>
        <el-table-column align="center" prop="schoolCate" label="类别" width="62px"></el-table-column>

        <el-table-column prop="toudang2015" label="计划数|投档数" class-name="mergeTh" align="center">
          <el-table-column prop="toudang2019" :label="nowYear - 2 + ''" class-name="mergeTh-child" align="center"
                           min-width="68px"></el-table-column>
          <el-table-column prop="toudang2020" :label="nowYear - 1 + ''" class-name="mergeTh-child" align="center"
                           min-width="68px"></el-table-column>
          <el-table-column prop="toudang2021" :label="nowYear + ''" class-name="mergeTh-child" align="center"
                           min-width="68px">
            <template slot-scope="scope">
              <b>{{ scope.row.toudang2021 }}</b>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="shift_line2019" label="投档线" width="141" align="center" class-name="mergeTh">
          <el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2019" :label="nowYear - 2 + ''"
                           min-width="70px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2020" :label="nowYear - 1 + ''"
                           min-width="70px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2021" :label="nowYear + ''"
                           min-width="70px">
            <template slot-scope="scope">
              <b>{{ scope.row.shiftLine2021 }}</b>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="ranking2019" label="投档位次" width="150" align="center" class-name="mergeTh">
          <el-table-column align="center" class-name="mergeTh-child" prop="ranking2019" :label="nowYear - 2 + ''"
                           min-width="72px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="ranking2020" :label="nowYear - 1 + ''"
                           min-width="72px"></el-table-column>
          <el-table-column align="center" class-name="mergeTh-child" prop="ranking2021" :label="nowYear + ''"
                           min-width="72px">
            <template slot-scope="scope">
              <b>{{ scope.row.ranking2021 }}</b>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="PlanYear + '计划'" align="center" width="45px">
          <template slot-scope="scope">
            <span v-if="scope.row.plan2022 > scope.row.plan2021" class="icon-top">
              {{ scope.row.plan2022 }}<i>↑</i>
            </span>
            <span v-else-if="scope.row.plan2021 > scope.row.plan2022" class="icon-bottom">
              {{ scope.row.plan2022 }}<i>↓</i>
            </span>
            <span v-else>{{ scope.row.plan2022 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服从调剂" width="76px">
          <template slot-scope="scope">
            <span style="float: right;font-weight:bolder">
              <span style="margin-left: 30px;" v-show="Admission">{{ scope.row.majorPlan }}|</span>
              <el-radio-group v-model="scope.row.schemeChange" @change="schemeChangeChange(scope.row.schemeChange, scope.row)">
                <el-radio label="0" style="margin-right: 6px">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="40">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="deleteScheme(scope.$index, tableData, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="right-btn-box" v-if="false">
      <el-button style="background-color: red;" circle @click="showSysStatement()">声明</el-button>
      <el-button v-if="infos.isAutoCreate" style="background-color: #01A4E9" circle @click="regenerateScheme()">重新<br>生成</el-button>
      <el-button style="background-color: #f96630;" circle>{{ schoolCheckedNumber }}</el-button>
      <el-button style="background-color: #f96630;" circle @click="saveScheme(tableData)">保存</el-button>
      <el-button v-if="infos.majorType == user.major && infos.subject1 == user.subject1 && infos.subject2 == user.subject2" style="background-color: #67C23A;" circle @click="update()">修改</el-button>
      <el-button v-if="infos.majorType != user.major || infos.subject1 != user.subject1 || infos.subject2 != user.subject2" style="background-color: #808080;" circle @click="alertMsg()">修改</el-button>
      <el-button style="background-color: #409eff;" circle @click="openHealthDialog()">体检</el-button>
      <el-button style="background-color: #7870b6;" circle @click="goToAdministration()">上一级</el-button>
    </div>

    <!-- 右侧悬浮 -->
    <div id="npt">
      <div style="background-color: #E04A4A;" @click="showSysStatement()">
        <i class="icon-el el-icon-warning-outline"></i>
        <span>声明</span>
      </div>
      <div style="background-color: #d0756c;" v-if="infos.isAutoCreate" @click="regenerateScheme()">
        <i class="icon-el el-icon-refresh-right"></i>
        <span>重新<br>生成</span>
      </div>
      <div style="background-color: #D0B000;">
        <img class="icon" src="~@/assets/images/design/icon_school.png" alt="icon" />
        <span>{{ schoolCheckedNumber }}</span>
      </div>
      <div style="background-color: #E29345;" @click="saveScheme(tableData)">
        <img class="icon" src="~@/assets/images/design/icon_save.png" alt="icon" />
        <span>保存</span>
      </div>
      <div v-if="infos.majorType == user.major && infos.subject1 == user.subject1 && infos.subject2 == user.subject2" style="background-color: #5DBE2D;" @click="update()">
        <i class="icon-el el-icon-edit-outline"></i>
        <span>修改</span>
      </div>
      <div v-if="infos.majorType != user.major || infos.subject1 != user.subject1 || infos.subject2 != user.subject2" style="background-color: #5DBE2D;" @click="update()">
        <i class="icon-el el-icon-edit-outline"></i>
        <span>修改</span>
      </div>
      <div style="background-color: #1B94D2;" @click="openHealthDialog()">
        <img class="icon" src="~@/assets/images/design/icon_tijian.png" alt="icon" />
        <span>体检</span>
      </div>
      <div style="background-color: #415B8A;" @click="goToAdministration()">
        <img class="icon" src="~@/assets/images/design/icon_return.png" alt="icon" />
        <span>上一级</span>
      </div>
    </div>
    <!--  体检限制弹窗  -->
    <health-dialog v-if="showHealthDialog" :healthVisible="showHealthDialog" @closeHealthDialog="closeHealthDialog"></health-dialog>
    <SysStatement title="系统声明"
                  :dialog-visible.sync="sysStatementDialog"
    />
    <!-- 全景预览弹窗 -->
    <SchemeDialog ref="$schemeDialog"
      @confirm="onConfirmScheme"
      @delete="onConfirmScheme"
    />

    <!-- 学校简介 -->
    <el-dialog :visible.sync="schoolIntroduce.open" :close-on-click-modal="false" class="school-info-dialog">
      <div class="school-info-remark" >
        重要声明：本系统院校及专业备注信息均源自各校官网、官微、公开说明及招生计划汇编，可能存在院校临时调整或不可落地的情况，仅供参考。如作为填报依据，请务必向相关院校核实。本系统不作任何保证，不承担任何法律责任。
      </div>
      <div v-if="schoolIntroduce.type === 'major'" v-html="schoolIntroduce.data" style="cursor: pointer;font-size: 16px;width: 100%;margin: auto;color: #000000;">
      </div>
      <div class="school-info-container" v-if="schoolIntroduce.type === 'school'">
        <div class="school-info-card">
          <div class="card-title">院校简介</div>
          <div class="card-content" v-html="schoolIntroduce.schoolDesc"></div>
        </div>
        <div class="school-info-card">
          <div class="card-title">招生政策</div>
          <div class="card-content" v-html="schoolIntroduce.policy"></div>
        </div>
        <div class="school-info-card">
          <div class="card-title">特殊班型</div>
          <div class="card-content" v-html="schoolIntroduce.specialClass"></div>
        </div>
        <div class="school-info-card">
          <div class="card-title">章程摘要</div>
          <div class="card-content" v-html="schoolIntroduce.constitution"></div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { request } from '@/util/request'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import SysStatement from "@/components/SysStatement.vue"
import healthDialog from "@/components/healthDialog.vue";
import SchemeDialog from '@/components/SchemeDialog.vue'
import { deepClone } from '@/util'

export default {
  components: {healthDialog, SysStatement, SchemeDialog},
  provide() {
    return {
      getScheme: this.getScheme,
      saveScheme: this.saveScheme,
    }
	},
  inject: ['reload'],
  data() {
    return {
      isExpansion: true,
      nowYear: '',
      PlanYear: '',
      MajorNowYear: '',
      MajorPlanYear: '',
      // 预览title
      schemeName: '',
      schemeRecruitType: '',
      switchStyle: 'blue',
      place: null,
      Admission: false,
      pttable: true,
      tqtable: false,
      fraction: '',
      batch: '',
      infos: [],
      tableData: [],
      loading: true,
      saving: false,
      stuId: '',
      user: [],
      del: [],
      majorList: [],
      setIds: [],
      dropList: [
        {
          value: '1',
          label: '志愿A'
        },
        {
          value: '2',
          label: '志愿B'
        },
        {
          value: '3',
          label: '志愿C'
        },
        {
          value: '4',
          label: '志愿D'
        },
        {
          value: '5',
          label: '志愿E'
        },
        {
          value: '6',
          label: '志愿F'
        },
        {
          value: '7',
          label: '备选'
        },
        {
          value: '8',
          label: '取消'
        },
      ],
      zyList: [
        {
          value: '1',
          label: '专业1'
        },
        {
          value: '2',
          label: '专业2'
        },
        {
          value: '3',
          label: '专业3'
        },
        {
          value: '4',
          label: '专业4'
        },
        {
          value: '5',
          label: '专业5'
        },
        {
          value: '6',
          label: '专业6'
        },
        {
          value: '7',
          label: '备选'
        },
        {
          value: '8',
          label: '取消'
        },
      ],
      schemeNameList: [
        { value: '1', label: '志愿1' },
        { value: '2', label: '志愿2' },
        { value: '3', label: '志愿3' },
        { value: '4', label: '志愿4' },
        { value: '5', label: '志愿5' },
        { value: '6', label: '志愿6' },
        { value: '备选', label: '备选' },
      ],
      majorNameList: [
        {
          value: '专业1',
          label: '专业1'
        },
        {
          value: '专业2',
          label: '专业2'
        },
        {
          value: '专业3',
          label: '专业3'
        },
        {
          value: '专业4',
          label: '专业4'
        },
        {
          value: '专业5',
          label: '专业5'
        },
        {
          value: '专业6',
          label: '专业6'
        },
        {
          value: '备选',
          label: '备选'
        }
      ],
      schoolCheckedNumber: '',
      sysStatementDialog: false,
      showHealthDialog: false,
      expandTxt: "专业展开",
      expandRowKeys: [], // 用于存储展开的行的 keys
      schoolIntroduce: {
        open: false,
        type: 'school',
        schoolDesc: '', // 院校简介
        constitution: '', // 招生章程
        policy: '', // 招生政策
        specialClass: '', // 特殊班型
        warning: '', // 院校预警
      },
    }
  },
  created() {
    this.infos = this.$route.params.info
    this.infos = JSON.parse(localStorage.getItem('volunteer'))
    const user = localStorage.getItem("stu");
    this.user = JSON.parse(user)
    this.stuId = this.user.id
    this.timer = setTimeout(async () => {   //设置延迟执行
      let res = await this.getScheme()
      this.initTableData(res)
    }, 1000);
    if (this.infos.batch.indexOf('提前') !== -1) {
      this.tqtable = true
      this.pttable = false
    }
    this.getDataYearOfDict()
  },
  mounted() { },

  computed: {
    tableDataFilter() {
      return this.tableData.filter(item => ![null, undefined,''].includes(item.schoolCode))
    },
    expandObject () {
      return {
        'el-icon--right el-icon-arrow-down': this.isExpansion,
        'el-icon--right el-icon-arrow-up': !this.isExpansion
      }
    }
  },
  methods: {
    async onConfirmScheme() {
      this.loading = true
      let res = await this.getScheme()
      this.tableData = res
    },

    toggleExpansionAll() {
      this.isExpansion = !this.isExpansion
      this.expandTxt = this.isExpansion ? '专业展开' : '专业收起'
      if (this.isExpansion) {
        this.expandRowKeys = this.tableData.map(item => item.id);
      } else {
        this.expandRowKeys = [];
      }
    },
    handleExpandChange(row) {
      if (this.expandRowKeys.includes(row.id)) {
        // 如果当前行已经在展开状态，则将其从 expandRowKeys 中移除
        this.expandRowKeys = this.expandRowKeys.filter(key => key !== row.id)
      } else {
        // 如果当前行不在展开状态，则将其添加到 expandRowKeys 中
        this.expandRowKeys.push(row.id)
      }
    },
    getDataYearOfDict() {
      this.$api.getDict({ dictType: this.infos.batch }).then(res => {
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg)
        }
        res.data.forEach(item => {
          if (item.dictName === 'now') {
            this.nowYear = item.dictValue
          } else if (item.dictName == "plan") {
            this.PlanYear = item.dictValue
          }
          else if (item.dictName == "majornow") {
            this.MajorNowYear = item.dictValue
          } else if (item.dictName == "majorplan") {
            this.MajorPlanYear = item.dictValue
          }
        })
      })
    },
    async tableRowSort(sortNum, scope) {
      if (this.tableData.length < 2) {
        return
      }
      let item = this.tableData.splice(scope.$index, 1)
      this.tableData.splice(sortNum, 0, ...item)
      this.$refs['popover-' + scope.row.schoolCode].doClose()
      // 刷新编号
      this.tableData.forEach((item, index) => item.schemeNum = index + 1)
      this.$nextTick(() => {
        // 关闭自己
        this.$refs.elTable.toggleRowExpansion(item[0], false)
        this.tableData.map(item => this.$refs.elTable.toggleRowExpansion(item, false))
      })
    },
    tableChildRowSort(sortNum, data) {
      if (data.parent.row.majorList.length < 2) {
        return
      }
      let item = data.parent.row.majorList.splice(data.child.$index, 1)
      data.parent.row.majorList.splice(sortNum, 0, ...item)
      //更新排序sort
      data.parent.row.majorList.forEach(function (item, index) {
        item.sort = '专业' + (index + 1);
      });
      this.$refs['popover-child-' + data.child.row.majorCode].doClose();
    },

    // 将文本中的字面"/n"替换为真实换行，并确保返回字符串以便在模板中使用
    normalizePopoverContent(text) {
      if (text === null || text === undefined) return '';
      return String(text).replace(/\/n/g, '\n');
    },

    getPdf(url) {
      var title = this.schemeName
      html2Canvas(document.querySelector(url), {
        allowTaint: true,
        taintTest: false,
        logging: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 1.5, //将分辨率提高到特定的DPI 提高四倍
        // dpi:300,
        scale: 1.5 //按比例增加分辨率
      }).then(canvas => {
        var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向

        var ctx = canvas.getContext('2d'),
          a4w = 240, a4h = 260,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        while (renderedHeight < canvas.height) {
          var page = document.createElement("canvas");
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页

          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', -15, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) {
            pdf.addPage();//如果后面还有内容，添加一个空页
          }
        }
        //保存文件
        pdf.save(title + '.pdf')

      })
    },
    async updateMajor(schoolIndex, majorIndex, majorList, name) {
      let majorArray = JSON.parse(majorList);
      majorArray.forEach(function (item, index) {
        if (majorIndex === index) {
          item.sort = name;
        }
      });
      this.tableData[schoolIndex].majorList = majorArray;
      try {
        await this.saveScheme(this.tableData);
      } catch (err) {
        console.error('保存失败', err);
      }
    },
    // 删除已选专业
    deleteRow(index, childIndex, rows) {
      this.$confirm('确定删除专业嘛?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 1. 清空 sort
        this.tableData[index].majorList[childIndex].sort = '';
        // 2. 移到未选专业
        this.tableData[index].notMajorList.push(this.tableData[index].majorList[childIndex]);
        // 3. 删除 majorList 中对应项
        rows.splice(childIndex, 1);
        // 4. 重新排序
        this.tableData[index].majorList.forEach((item, idx) => {
          item.sort = '专业' + (idx + 1);
        });
        this.$set(this.tableData, index, this.tableData[index]);
        // 5. 保存
        // this.saveScheme();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    zyb() {
      let sortList = []
      let bList = []
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].schemeName == "备选") {
          bList.push(this.tableData[i])
        } else {
          sortList.push(this.tableData[i])
        }
      }
      bList.forEach(i => {
        sortList.push(i)
      })
      this.tableData = sortList
      for (let m = 0; m < this.tableData.length; m++) {
        let sortList = []
        let bList = []
        for (var i = 0; i < this.tableData[m].majorList.length; i++) {
          if (this.tableData[m].majorList[i].sort == "备选") {
            bList.push(this.tableData[m].majorList[i])
          } else {
            sortList.push(this.tableData[m].majorList[i])
          }
        }
        bList.forEach(i => {
          sortList.push(i)
        })
        this.tableData[m].majorList = sortList
      }
    },
    showSysStatement(){
      this.sysStatementDialog =true;
    },
    regenerateScheme(){
      this.$router.replace('/autoGenerate');
    },
    async saveScheme(tableData = []) {
      // 防止并发保存
      if (this.saving) {
        return Promise.reject(new Error('saving in progress'));
      }
      this.saving = true;
      this.loading = true;
      try {
        // 1. 去重并排序（纯函数返回新数组）
        const deduped = this.filterTableDataDuplicates(tableData);

        // 2. 构造发送的 payload（后端期望 majorList 为字符串）
        const payload = deduped.map(i => {
          const item = { ...i };
          const majorListStr = item.majorList !== undefined && item.majorList !== null
            ? (typeof item.majorList === 'string' ? item.majorList : JSON.stringify(item.majorList))
            : null;
          return {
            id: item.id,
            schoolCode: item.schoolCode,
            schoolName: item.schoolName,
            schemeNum: item.schemeNum,
            majorList: majorListStr,
            programmeName: item.programmeName,
            schemeName: item.schemeName,
            programmeId: item.programmeId,
            stuId: item.stuId,
            batch: item.batch,
            fraction: item.fraction,
            num: item.num,
            schemeChange: item.schemeChange,
            majorPlan: item.majorPlan,
            plan2022: item.plan2022,
            majorType: item.majorType,
            groupCode: item.groupCode,
            score: item.score,
            precedence: item.precedence,
            subject1: item.subject1,
            subject2: item.subject2,
            recruitType: item.recruitType
          };
        });

        // 3. 本地保留发送的 scheme 副本
        this.scheme = payload.slice();

        // 4. 发送请求
        const res = await request({
          method: 'post',
          url: 'stuSchemeV2/saveScheme',
          data: this.scheme
        });

        // 5. 结果检查
        if (![0, 200].includes(res.code)) {
          this.$message.error(res.msg || '保存失败');
          throw new Error(res.msg || '保存失败');
        }

        this.$message.success('保存成功！');
        await this.getScheme();
        return res;
      } catch (err) {
        // 上层调用可捕获错误并处理
        throw err;
      } finally {
        this.saving = false;
        this.loading = false;
      }
    },

    // 纯函数版去重（不修改传入对象）
    filterTableDataDuplicates (tableData = []) {
      // 1. 过滤掉无效 schoolCode 的项
      const valid = tableData.filter(item => ![null, undefined, ''].includes(item.schoolCode));
      // 2. Map 去重（保留第一次出现）
      const seen = new Map();
      const deduped = [];
      for (const orig of valid) {
        const key = `${String(orig.schoolCode || '')}_${String(orig.groupCode || '')}`;
        if (seen.has(key)) continue;
        seen.set(key, true);
        const clone = { ...orig };
        // 统一处理 notMajorList（如果需要置空）
        clone.notMajorList = null;
        deduped.push(clone);
      }
      // 3. 把 schemeName === '备选' 的记录移到末尾（保持顺序）
      const main = [];
      const backup = [];
      for (const it of deduped) {
        if (it.schemeName === '备选') backup.push(it);
        else main.push(it);
      }
      return main.concat(backup);
    },
    goToAdministration() {
      this.$router.push({
        path: '/schemeDesign'
      })
    },
    update() {
      const programme = this.tableData;
      const user = sessionStorage.getItem("user");
      let stu = JSON.parse(user)
      let majorType = this.infos.majorType;
      programme.forEach(function (item, index) {
        if (item.majorType === null) {
          item.majorType = majorType;
        }
      });
      this.$router.push({
        path: '/schemeMake',
        query: {
          examineeId: this.stuId,
          student: JSON.stringify(programme)
        }
      })
    },
    alertMsg(){
      this.$alert('您已修改考生选科要求，原方案仅支持院校排序和删除，无法新增院校或修改专业。如需调整方案，请在“我的档案”中更改选科要求。', '提示', {
        confirmButtonText: '确定'
      });
    },
    updateName() {
      request({
        method: 'POST',
        url: 'stuSchemeV2/updateName',
        params: {
          name: this.schemeName,
          programmeId: this.tableData[0].programmeId,
          stuId: this.stuId
        }
      }).then(res => {
        if (res.code == 0 || res.code == 200) {
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          });
        }
      })
    },
    // 更新方案
    async updateScheme(index, schemeName) {
      this.tableData[index].schemeName = schemeName;
      try {
        await this.saveScheme(this.tableData);
      } catch (err) {
        console.error('保存失败', err);
      }
    },
    deleteScheme(index, rows, row) {
      this.$confirm('确定删除该志愿嘛?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (rows.length <= 1) {
          this.$message({
            message: '至少保留一个志愿~',
            type: 'error'
          });
        } else {
          request({
            method: 'POST',
            url: 'stuSchemeV2/deleteScheme',
            params: {
              Id: row.id,
            }
          }).then(res => {
            if (res.code == 0 || res.code == 200) {
              rows.splice(index, 1);
              // 刷新编号
              this.tableData.forEach((item, index) => item.schemeNum = index + 1)
              this.$message({
                message: '删除成功！',
                type: 'success'
              });
              this.schoolCheckedNumber=this.tableData.length;
            } else {
              this.$message({
                message: '删除失败~',
                type: 'error'
              });
            }
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getScheme() {
      // this.loading = true
      return request({
        method: 'POST',
        url: 'stuSchemeV2/getScheme',
        params: {
          stuId: this.stuId,
          programmeId: this.infos.programmeId,
          batch: this.infos.batch,
          precedence: this.infos.precedence,
          majorType: this.infos.majorType,
        }
      }).then(res => {
        this.loading = false
        if (res.code !== 0) {
          Promise.reject(res.msg)
          return this.$message.error(res.msg)
        }
        res.data = res.data || []
        this.batch = res.data[0].batch
        this.place = res.data[0].ranking
        if (res.data[0].schemeName == null) {
          this.schoolCheckedNumber = 0;
        } else {
          this.schoolCheckedNumber = res.data.length;
        }
        this.schemeName = res.data[0].programmeName
        this.schemeRecruitType = res.data[0].recruitType

        if (this.batch == '国家专项' || this.batch == '地方专项' || this.batch == '本科一批' || this.batch == '本科二批' || this.batch == '高职专科') {
          this.Admission = true
        }
        res.data.map(item => {
          item.majorList = item.majorList ? JSON.parse(item.majorList) : []
          item.majorListLen = item.majorList.length
          item.notMajorList = item.notMajorList ? JSON.parse(item.notMajorList) : []
          item.showCheckMajor = true // 默认显示已选专业
        })
        return res.data
      }).finally(() => {
        this.loading = false
      })
    },
    initTableData(responseData) {
      let data = deepClone(responseData || [])
      this.tableData = data
      // 设置展开的行
      this.expandRowKeys = this.tableData.map(item => item.id);
    },
    schemeChangeChange(value, row){
      if(value == '1'){
        this.$confirm('如果选择不服从专业调剂，有被院校退档的风险，考生请根据自身情况谨慎选择。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        }).catch(() => {
          row.schemeChange = '0';
          this.$message({
            type: 'info',
            message: '已取消修改服从调剂'
          });
        });
      }
    },
    async handleSortChange({prop, order} ){
      // 根据排序信息对数据进行排序
      this.tableData.sort((a, b) => {
        let valueA = a[prop];
        let valueB = b[prop];
        if (valueA === null || valueA === undefined) return 1;
        if (valueB === null || valueB === undefined) return -1;
        if (prop === "probabilityNum" && typeof valueA === "number" && typeof valueB === "number") {
          if (valueA !== valueB) {
            return order === "ascending" ? valueA - valueB : valueB - valueA;
          } else {
            let groupProposedwcA = a['groupProposedwc'];
            let groupProposedwcB = b['groupProposedwc'];
            return order === "ascending" ? groupProposedwcA - groupProposedwcB : groupProposedwcB - groupProposedwcA;
          }
        }

        return false;
      });
      //遍历table 重置sort
      this.tableData.forEach((item, index)=>{
        item.schemeNum = (index+1);
        item.schemeName = (index+1);
      });
      // 调用保存接口并等待完成
      try {
        await this.saveScheme(this.tableData);
      } catch (err) {
        console.error('保存失败', err);
      }
      this.$nextTick(() => {
        // 关闭所有
        this.tableData.map(item => this.$refs.elTable.toggleRowExpansion(item, false))
      })
    },
    // 打开体检限制弹窗
    openHealthDialog () {
      this.showHealthDialog = true
    },
    closeHealthDialog () {
      this.showHealthDialog = false
    },
    // 切换已选、未选
    toggleCheckMajor (props, type) {
      let index = props.$index
      this.tableData[index].showCheckMajor = type == 1 ? true : false
      this.$set(this.tableData, index, this.tableData[index]);
    },
    // 选择专业
    selectMajor (childIndex, list, index) {
      if (list.length >= 6) {
        this.$message({
          message: '当前院校已选择6个专业，不能再选择了~',
          type: 'warning'
        });
        return
      }

      this.tableData[index].notMajorList[childIndex].sort = '专业' + (list.length + 1);
      list.push(this.tableData[index].notMajorList[childIndex]);
      this.tableData[index].majorList = list
      this.tableData[index].majorListLen = list.length
      this.tableData[index].notMajorList.splice(childIndex, 1);
      this.$set(this.tableData, index, this.tableData[index]);
    },
    // 院校 zhu
    introduceSchool(code) {
      request({
        method: 'get',
        url: 'schoolV2/getSchoolBaseDetail?code='+code,
      }).then(res => {
        if (res.code === 0 && res.data) {
          this.schoolIntroduce.type = 'school'
          this.schoolIntroduce.schoolDesc = res.data.schoolDesc ? res.data.schoolDesc : ''; // 院校简介
          this.schoolIntroduce.constitution = res.data.constitution ? res.data.constitution : ''; // 章程摘要
          this.schoolIntroduce.policy = res.data.policy ? res.data.policy : ''; // 招生政策
          this.schoolIntroduce.specialClass = res.data.specialClass ? res.data.specialClass : ''; // 特殊班型
          this.schoolIntroduce.warning = res.data.warning ? res.data.warning : ''; // 院校预警
          this.schoolIntroduce.open = true
        }
      })
    },
    // 专业 zhu
    introduceMajor(majorDesc) {
      this.schoolIntroduce.data = majorDesc;
      this.schoolIntroduce.type = 'major'
      this.schoolIntroduce.open = true
    },
  },
}
</script>

<style lang="stylus">
.icon-top
  color #39B830
.icon-bottom
  color #f56c6c
.preview-container
  .el-table th.el-table__cell
    background-color: #f0f0f0 !important;

  .el-table--group
    border unset
  .el-table--border .el-table__cell
    border-right unset
  .el-table--border::after, .el-table--group::after, .el-table::before {
    display none
  }
  .el-table__expanded-cell[class*=cell]
    padding: 0;

  .el-radio__label
    padding-left: 4px;

</style>
<style lang="stylus" scoped>
pageWidth = 1400px
$color-theme = #f96630

.preview-container
  width: pageWidth;
  min-height: BodyMinHeight;
  margin: 0 auto;
  font-size: 16px;

  .title-box
    padding: 20px 0;
    line-height: 40px;
    text-align: center;

    .title
      font-size: 20px;
      font-weight: bold;

    span
      font-size: 16px;
      margin-left: 5px;

    .stu-info
      margin-left: 30px;

  .handle-box
    margin-bottom 20px

  .table-section
    padding: 0 0 40px 0;

    .sort-box
      display: flex;
      align-items: center;
      cursor: pointer;
      text-align: center;

      .sort-item
        flex: 1;
        text-align: center;
        line-height: 30px;
        color: $color-theme;

.sortSection
  display flex
  align-items center
  flex-wrap wrap
  &-button
    height: 30px;
    min-width: 30px;
    padding: 0 2px;
    // color: #333;
    border-radius: 4px;
  &-item
    display inline-flex
    align-items center
    justify-content center
    box-sizing border-box
    height 30px
    min-width 30px
    padding 0 2px
    background #fff
    color #333
    border-radius 4px
    margin-right 10px
    margin-bottom 10px
    border 1px solid #dcdfe6
    cursor pointer
    font-size 14px
    &.is-major {
      font-size 12px
      &.is-active, &:hover {
        background #67c23a
        border-color #67c23a
        color #fff
      }
    }
    &.is-active {
      background var(--primaryColor)
      border-color var(--primaryColor)
      color #fff
    }
    &:hover {
      background var(--primaryColor)
      border-color var(--primaryColor)
      color #fff
    }
    &:last-child
      margin-right 0
.tab-box {
  display flex
  align-items center
  .tab-item {
    position relative
    padding 0 15px
    text-align center
    line-height 48px
    font-size 13px
    color #333
    cursor pointer
    &.is-active {
      color var(--primaryColor)
      font-weight bold
      &:after {
        content: ''
        display block
        width 40%
        height 3px
        background var(--primaryColor)
        border-radius 3px
        position absolute
        bottom 0
        left 30%
      }
    }
  }
}
.name-tag {
  height: 16px;
  font-size: 10px;
  span {
    margin-right 10px
  }
}
.flex-box
  display: flex
  align-items: center
  justify-content: flex-start
 .warning-icon
   cursor pointer
   color: #f56c6c
   margin-right 5px
   position absolute
   left 10
  .code-box
    padding-left 20px
</style>
